import React from "react";
import { map, startCase } from 'lodash';
import { IJobCost } from "../models/jobCostModel";
import * as employeeActions from '../employeeActions';
import util from "../util";
import { AsyncContent, Expander, sortableComponent } from "./sharedComponents";
import globalRelay from "../globalRelay";
import { IChangeOrder } from "Scripts/models/changeOrderModel";

const personnelTitle = `${globalRelay.config!.shortCompanyName} Personnel`;

const HistoryTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable" cellPadding="0" cellSpacing="0">
			<HistoryTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<HistoryTableBody list={list} {...childProps} />
		</table>
	);
});

function HistoryTableHeader({ sortKey, updateSort }) {
	function getClassName (key) {
		return (key === sortKey) ? 'sorted' : '';
	}

	return (
		<thead>
			<tr>
				<td />
				<td className={getClassName('sortDate')} onClick={e => updateSort('sortDate')}>Date</td>
				<td className={getClassName('description')} onClick={e => updateSort('description')}>Description</td>
				<td className={getClassName('employeeName')} onClick={e => updateSort('employeeName')}>{ personnelTitle }</td>
				<td />
			</tr>
		</thead>
	);
}

function HistoryTableBody({ list, ...childProps }) {
	const rows = map(list, item => {
		return <HistoryTableRow item={ item } key={ item.key } {...childProps} />;
	});

	return (
		<tbody>
			{rows}
		</tbody>
	);
}

function HistoryTableRow({ item }) {
	return (
		<tr>
			<td />
			<td>{ util.dateHelper.formatDate(item.sortDate, { userFriendly: true }) }</td>
			<td>{ item.description || '-' }</td>
			<td>{ item.employeeName }</td>
			<td />
		</tr>
	);
}

export default function HistorySection({ emptyTitle, contract }: { emptyTitle: string, contract: (IJobCost | IChangeOrder)} ) {
	const list = map(contract.statusLog, logItem => {
		const statusEmployee = employeeActions.getEmployeeByUserKey(logItem.createdById);

		return { key: logItem.key, sortDate: logItem.dateCreated, description: startCase(logItem.status), employeeName: (statusEmployee && statusEmployee.fullName) || '-' };
	});

	const itemEmployee = employeeActions.getEmployeeByUserKey(contract.createdById);
	list.push({ key: contract.key, sortDate: contract.dateCreated, description: 'Estimate', employeeName: (itemEmployee && itemEmployee.fullName) || '-' });

	const table = <HistoryTable list={ list } initialSortKey="sortDate" initialSortDirection={ -1 } />

	return (<Expander title={ `${contract.relayNumber} - ${contract.name}` } contentClassNames={ ['inner'] }>
		<AsyncContent emptyContent={emptyTitle} hasData={ list.length}>{ table }</AsyncContent>
	</Expander>);
}
